import { ChangeDetectionStrategy, Component, Input } from '@angular/core';
import { SvgComponent } from 'icon';
import { PCProduct } from 'product';
import { TranslatePipe } from 'translate';

@Component({
  selector: 'lib-table-data-products',
  standalone: true,
  imports: [SvgComponent, TranslatePipe],
  templateUrl: './table-data-products.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class TableDataProductsComponent {
  @Input() product: PCProduct;
}
